import Plus from 'components/icons/actions/Plus';

const FaqItem = ({ question, answer }) => {
  return (
    <li className="w-full border-b border-solid border-green-140 pb-3">
      <details className="group w-full">
        <summary className="flex cursor-pointer items-center gap-4 py-2 text-green-140 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-100 focus-visible:ring-offset-2">
          <p className="h4 flex-1 font-semibold">{question}</p>
          <Plus className="h-6 w-6 shrink-0 transform transition-transform duration-300 ease-in-out group-open:rotate-45" />
        </summary>
        <div
          className="text [&_a]:textMd mt-2 text-green-140  
                     [&_a:hover]:opacity-70  
                     [&_a]:text-green-140  
                     [&_a]:underline  
                     [&_li]:ml-4
                     [&_p]:pb-3"
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </details>
    </li>
  );
};

FaqItem.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
};

const FAQs = ({ data: { title, questions } }) => {
  return (
    <section className="flex flex-col justify-center bg-family-beige-100 px-4 pb-14 pt-8 bp2:py-16">
      <h2 className="h1 px-4 pb-6 text-center text-green-140 bp2:pb-10">{title}</h2>
      <ul className="mx-auto flex w-full max-w-4xl list-none flex-col gap-6 px-4">
        {questions.map(({ key, question, answer }) => (
          <FaqItem key={key} question={question} answer={answer} />
        ))}
      </ul>
    </section>
  );
};

FAQs.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        question: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default FAQs;
